import { axios } from 'core/api';
import { apiRoutes } from 'core/api/api.routes';
import { mapDataToRequest } from 'core/utils/json-request.utils';

export const saveLanguage = async (language: string): Promise<void> => {
  await axios.post<void>(apiRoutes.settings.saveLanguage(), mapDataToRequest({ language }));
};
